import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { incidentIdField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';

export const workplaceReportsMetadata = {
  displayName: msg({
    message: 'Workplace incidents',
    context: 'Activity data schema name for workplace incidents',
  }),
  fields: {
    ...coreFields,
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Workplace report remediation spend',
        context: 'The display name for a metric',
      }),
    },
    incident_id: incidentIdField,
    is_discrimination: {
      displayName: msg({
        message: 'Is discrimination',
        context: 'The display name for a dimension',
      }),
    },
    is_filed_by_own_workforce: {
      displayName: msg({
        message: 'Is filed by own workforce',
        context: 'The display name for a dimension',
      }),
    },
    is_filed_to_national_contact_points_for_oecd: {
      displayName: msg({
        message:
          'Is filed to National Contact Points for OECD Multinational Enterprises',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
